import React, { useState, useEffect } from "react";

import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";
import telecomImg from "../../assets/telecommunication.png";

import { FaRobot, FaBroadcastTower } from "react-icons/fa";

const responsiveStyles = `
  .tc-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .tc-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .tc-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47,183,164,0.7);
  }

  .tc-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0,0,0,0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 520px;
    max-width: 100%;
  }

  .tc-header-icon-box {
    width: 36px;
    height: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .tc-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    min-width: 0;
  }

  .tc-header-right-deco-left {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(0 0, 60% 0, 0 100%);
  }

  .tc-header-right-deco-right {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .tc-header-title {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
  }

  .tc-header-title h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  .tc-main {
    display: flex;
    padding: 60px 80px;
    gap: 60px;
    align-items: center;
  }

  .tc-image-wrap {
    flex: 1;
  }

  .tc-image-wrap img {
    width: 100%;
    max-width: 650px;
    display: block;
  }

  .tc-accordion {
    flex: 1.2;
  }

  .tc-accordion-item {
    margin-bottom: 18px;
  }

  .tc-accordion-header {
    background: linear-gradient(90deg,#2fb7a4 0%,#2f6f9f 60%,#2f4a7f);
    color: #f4f7fb;
    padding: 8px 24px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tc-accordion-arrow {
    font-size: 22px;
    flex-shrink: 0;
    margin-left: 12px;
  }

  .tc-accordion-body {
    padding: 20px;
    color: #555;
  }

  /* ── Tablet: 768px – 1024px ── */
  @media (max-width: 1024px) {
    .tc-main {
      padding: 40px 40px;
      gap: 40px;
    }

    .tc-header-badge {
      width: auto;
      font-size: 14px;
      padding: 10px 16px;
    }

    .tc-header-title h2 {
      font-size: 24px;
    }
  }

  /* ── Mobile: ≤ 767px ── */
  @media (max-width: 767px) {
    .tc-header {
      flex-direction: column;
      height: auto;
    }

    .tc-header-left {
      flex: none;
      padding: 16px;
      min-height: 80px;
    }

    .tc-header-badge {
      width: 100%;
      font-size: 13px;
      padding: 10px 14px;
      gap: 8px;
    }

    .tc-header-right {
      flex: none;
      padding: 16px;
      min-height: 70px;
    }

    .tc-header-right-deco-left,
    .tc-header-right-deco-right {
      width: 50px;
    }

    .tc-header-title h2 {
      font-size: 20px;
    }

    .tc-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .tc-image-wrap {
      width: 100%;
    }

    .tc-image-wrap img {
      max-width: 100%;
    }

    .tc-accordion {
      width: 100%;
    }

    .tc-accordion-header {
      padding: 10px 16px;
      font-size: 14px;
    }

    .tc-accordion-body {
      padding: 16px;
      font-size: 14px;
    }
  }

  /* ── Very small phones: ≤ 400px ── */
  @media (max-width: 400px) {
    .tc-header-badge {
      font-size: 12px;
      padding: 8px 10px;
    }

    .tc-header-title h2 {
      font-size: 17px;
    }

    .tc-accordion-header {
      font-size: 13px;
      padding: 8px 12px;
    }

    .tc-accordion-body {
      padding: 14px;
      font-size: 13px;
    }
  }
`;

function TelecommunicationPage() {
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    const styleId = "tc-responsive-styles";
    if (!document.getElementById(styleId)) {
      const tag = document.createElement("style");
      tag.id = styleId;
      tag.innerHTML = responsiveStyles;
      document.head.appendChild(tag);
    }
    return () => {
      const existing = document.getElementById(styleId);
      if (existing) existing.remove();
    };
  }, []);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1.Incident - Switch Port Down / Flapping",
      content:
        "Bot switches log based on the incident tickets raised by the customer and copy logs in the ticket, and allocate to the Telecom Service"
    },
    {
      title: "2.Pending Tickets Follow-up With Customer",
      content:
        "Bot checks tickets in the pending customer and resolved status. Send reminders to customers for eliciting an update on the Telecom Service."
    },
    {
      title: "3.Quality Check For Customer Tickets",
      content:
        "RPA helps to check tickets quality with respect to category, status, escalation, handle time, response time, resolution time, reply templates, etc.,"
    },
    {
      title: "4.Client Satisfaction Surveys",
      content:
        "Bot to recover different reports from different applications, align the data in several different sheets to create a survey form, place the file in server for clients to access and share the URL carrying the survey form to the customers through SMS."
    },
    {
      title: "5.Monitor Network Usage Through Aggregation Of Data",
      content:
        "Bot Monitors the bandwidth usage over the remote monitoring of various telecom servers and business systems so that it does not exceed a pre-defined threshold."
    },
    {
      title: "6.Staff Daily Activity Report",
      content:
        "RPA helps to create report on staff activities like service ticket handling and resolution, events, email response, calls to customers, etc., which are handled during the shift and send it in an mail template to the supervisory group."
    }
  ];

  return (
    <div>

      {/* ===== HEADER ===== */}
      <div className="tc-header">
        {/* LEFT */}
        <div
          className="tc-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="tc-header-overlay" />

          <div className="tc-header-badge">
            <div className="tc-header-icon-box">
              <FaRobot style={{ color: "#fff", fontSize: "18px" }} />
            </div>

            <span>Robotic process automation - Use Cases</span>

            <span style={{ marginLeft: "auto" }}>›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="tc-header-right">
          <div className="tc-header-right-deco-left" />
          <div className="tc-header-right-deco-right" />

          <div className="tc-header-title">
            <FaBroadcastTower
              style={{
                fontSize: "32px",
                color: "#2fb7a4"
              }}
            />

            <h2>Telecommunication</h2>
          </div>
        </div>
      </div>

      {/* ===== MAIN SECTION ===== */}
      <div className="tc-main">
        {/* IMAGE */}
        <div className="tc-image-wrap">
          <img src={telecomImg} alt="Telecommunication" />
        </div>

        {/* ACCORDION */}
        <div className="tc-accordion">
          {data.map((item, i) => (
            <div key={i} className="tc-accordion-item">
              <div
                className="tc-accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span className="tc-accordion-arrow">
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="tc-accordion-body">{item.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TelecommunicationPage;
